import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import FolderIcon from '@material-ui/icons/Folder';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListSubheader from '@material-ui/core/ListSubheader';
import { inject } from 'mobx-react';
import { MenuData } from '../../store/MenuData/MenuData';
import Collapse from '@material-ui/core/Collapse';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { getFolders } from '@/api/apiList/folder';
import TextField from '@material-ui/core/TextField';
import { debounce, getQuery } from '@/utils/utils';
import eventBus from '@/utils/eventBus';
import { withRouter } from 'react-router-dom';

const { useState, useEffect, Fragment, memo } = React;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    nestedCur: {
      color: '#26c6da',
    },
    list: {
      width: '300px',
    },
    textField: {
      margin: theme.spacing(1),
      marginLeft: theme.spacing(4),
      width: 200,
    },
    iconStyle: {
      minWidth: '35px',
    },
  })
);

/**
 * @description 搜索防抖
 */
const changeMenuListFn = debounce((params: { searchData: string; menuList: FolderType[]; setMenuListFilter: Function }) => {
  const { searchData, menuList, setMenuListFilter } = params;
  if (!menuList.length) {
    return;
  }
  const menuFilter: FolderType[] = [];
  menuList.map((folder) => {
    const boardHasList: boardType[] = folder.childrens.filter((board) => board.boardName.toLowerCase().includes(searchData.toLowerCase()));
    if (boardHasList.length) {
      menuFilter.push({
        ...folder,
        childrens: [...boardHasList],
        open: searchData ? true : false,
      });
    } else if (folder.folderName.toLowerCase().includes(searchData.toLowerCase())) {
      menuFilter.push({
        ...folder,
        childrens: [],
        open: searchData ? true : false,
      });
    }
  });
  setMenuListFilter(menuFilter);
}, 1000);
function SwipeableTemporaryDrawer(props: { isOpenAside: boolean; openAside: (type: boolean) => void; history: any; menuList: newBackMenuType; setMenuList: (menuList: newBackMenuType) => void }) {
  const { isOpenAside, openAside, history, menuList, setMenuList } = props;
  const classes = useStyles();
  let [menuListFilter, setMenuListFilter] = useState<FolderType[]>([]); // 文件夹拷贝数据，配合搜索
  const [searchData, setSearchData] = useState('');
  // menuListFilter = menuListFilter.filter(item => item.folderID != 100068); // 暂时过滤经分
  /**
   * @description 高亮当前看板
   * @param folderList 文件夹列表
   */
  const setCurBoard = (folderList: FolderType[]) => {
    const folderID = getQuery('folderID'),
      boardID = getQuery('boardID');
    folderList.map((folder: FolderType) => {
      folder.childrens.map((board: boardType) => {
        board.cur = false;
      });
      if (folder.folderID == folderID) {
        folder.open = true;
        const curBoard = folder.childrens.find((board) => board.boardID == boardID) as boardType;
        curBoard.cur = true;
      }
    });
    setMenuListFilter(folderList);
  };
  const configMenu = (folderList: FolderType[]) => {
    setCurBoard(folderList);
  }; // 配置菜单并设置当前菜单展开的文件夹

  useEffect(() => {
    // 绑定菜单刷新
    eventBus.addListener('configMenu', (menuList: FolderType[]) => {
      console.log(menuList);
      configMenu(menuList);
    });
    getFolders().then((folderRes: any) => {
      const res: newBackMenuType = folderRes.result;
      res.pubFolders.map((v) => {
        v.folders.map((folder: FolderType) => {
          folder.childrens = folder.boards!;
        });
      });
      const folderList: FolderType[] = getQuery('folderID') ? res.pubFolders.find((v) => v.folders.some((vv) => vv.folderID == getQuery('folderID')))!.folders : res.pubFolders[0].folders;
      getQuery('folderID') && eventBus.emit('getBoard', folderList);
      configMenu(folderList);
      setMenuList(res);
    });
  }, []);
  useEffect(() => {
    changeMenuListFn({ searchData, menuList, setMenuListFilter });
  }, [searchData]);
  const handleClickMenu = (folderID: number) => {
    let menuData: FolderType = menuListFilter.find((folder) => folder.folderID == folderID) as FolderType;
    menuData.open = !menuData.open;
    setMenuListFilter([...menuListFilter]);
  };
  const sideList = () => {
    return (
      <div className={classes.list} role='presentation'>
        <List
          component='nav'
          aria-labelledby='nested-list-subheader'
          subheader={
            <TextField
              rowsMax={5}
              id='standard-basic'
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
              label='搜索'
              value={searchData}
              className={classes.textField}
            />
          }
          className={classes.root}
        >
          {menuListFilter.map((folder, folderIndex) => (
            <Fragment key={folder.folderID}>
              <ListItem
                button
                onClick={() => {
                  handleClickMenu(folder.folderID);
                }}
              >
                <ListItemIcon className={classes.iconStyle}>{folder.open ? <FolderOpenIcon /> : <FolderIcon />}</ListItemIcon>
                <ListItemText primary={folder.folderName} />
                {folder.open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
              <Collapse in={folder.open} timeout='auto' unmountOnExit>
                <List component='div' disablePadding>
                  {folder.childrens
                    .filter((v) => v.onlyWap != 2) //TODO开发中先注释，不然营销分析在移动端是隐藏的
                    .map((board, boardIndex) => (
                      <ListItem
                        onClick={() => {
                          const { folderID } = folder;
                          const { boardID } = board;
                          history.push(`/dashboard?folderID=${folderID}&boardID=${boardID}`);
                          setCurBoard(menuListFilter);
                          openAside(false);
                        }}
                        key={board.boardID}
                        button
                        className={`${classes.nested} ${board.cur ? classes.nestedCur : ''}`}
                      >
                        <ListItemIcon className={`${classes.iconStyle} ${board.cur ? classes.nestedCur : ''}`}>
                          <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText primary={board.boardName} />
                      </ListItem>
                    ))}
                </List>
              </Collapse>
            </Fragment>
          ))}
        </List>
      </div>
    );
  };

  return (
    <div>
      <SwipeableDrawer
        open={isOpenAside}
        onClose={() => {
          openAside(false);
        }}
        onOpen={() => {
          openAside(true);
        }}
      >
        {sideList()}
      </SwipeableDrawer>
    </div>
  );
}
export default inject((store: { MenuData: MenuData }) => {
  return {
    menuList: store.MenuData.menuList,
    setMenuList: store.MenuData.setMenuList,
  };
})(withRouter(memo(SwipeableTemporaryDrawer)));
